import { MovieClip } from '@play-co/timestep-core/ui';
import { Container } from '../../../odie';

import { RocketBlockProps } from '../../defs/block';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';
import { getBlockViewScale } from './FitWidthBlockSprite';

/*
    rocket block view
*/
export class RocketBlockView extends Container {
  public readonly animation!: MovieClip;

  // init
  //-------------------------------------------------------------------------
  constructor(props: RocketBlockProps) {
    // create base view
    super();

    this.animation = new MovieClip({
      superview: this.view,
      url: getMatch2AssetPath('blocks/power/rocket'),
      defaultAnimation: 'rocket_idle',
      scale: getBlockViewScale(88, props),
      r: props.id === 'rh' ? Math.PI / 2 : 0,
      fps: 40,
    });

    blockPositionView(this, props);
  }

  public static assets() {
    return [
      {
        url: getMatch2AssetPath('blocks/power/rocket'),
        loadMethod: MovieClip.animationLoader,
      },
    ];
  }
}
